import React, { useState, useCallback } from 'react';
import { Routes, Route } from 'react-router';

import { useLingui } from '@lingui/react/macro';

import { Config } from 'contexts/Config';
import ScreenHeader from 'components/ScreenHeader';
import PersistentFilters from 'components/PersistentFilters';
import TeamList from './TeamList';
import TeamAdd from './TeamAdd';
import Team from './Team';

function Teams() {
  const { t } = useLingui();
  const [breadcrumbConfig, setBreadcrumbConfig] = useState({
    '/teams': t`Teams`,
    '/teams/add': t`Create New Team`,
  });

  const buildBreadcrumbConfig = useCallback(
    (team) => {
      if (!team) {
        return;
      }

      setBreadcrumbConfig({
        '/teams': t`Teams`,
        '/teams/add': t`Create New Team`,
        [`/teams/${team.id}`]: `${team.name}`,
        [`/teams/${team.id}/edit`]: t`Edit Details`,
        [`/teams/${team.id}/details`]: t`Details`,
        [`/teams/${team.id}/users`]: t`Users`,
        [`/teams/${team.id}/access`]: t`Access`,
        [`/teams/${team.id}/roles`]: t`Roles`,
      });
    },
    [t]
  );

  return (
    <>
      <ScreenHeader streamType="team" breadcrumbConfig={breadcrumbConfig} />
      <Routes>
        <Route path="add" element={<TeamAdd />} />
        {/* so the nested <Team> route tree can match the rest */}
        <Route
          path=":id/*"
          element={<Team setBreadcrumb={buildBreadcrumbConfig} />}
        />
        <Route
          index
          element={
            <PersistentFilters pageKey="teams">
              <Config>
                {({ me }) => <TeamList path="/teams" me={me || {}} />}
              </Config>
            </PersistentFilters>
          }
        />
      </Routes>
    </>
  );
}

export { Teams as _Teams };
export default Teams;
